const validateUserForm = (values: any) => {
  const errors: any = {};
  
  const trimmedFirstname = values.Firstname?.trim();
  const trimmedMiddlename = values.Middlename?.trim();
  const trimmedLastname = values.Lastname?.trim();
  const trimmedUsername = values.Username?.trim();
  const trimmedCountersign = values.Countersign?.trim();
  const trimmedEmailid = values.Emailid?.trim();
  const trimmedPhonenumber = values.Phonenumber?.trim();
  const trimmedFaxnumber = values.Faxnumber?.trim();
 
  // Validate Salutation
  if (!values.Salutationtypeid) {
    errors.Salutationtypeid = "Please select Salutation";
  }

  // Validate First Name
  if (!trimmedFirstname) {
    errors.Firstname = "First name is mandatory";
  } else if (/\s/.test(trimmedFirstname)) {
    errors.Firstname = "No spaces allowed in First Name";
  }

   // Validate Middle Name
   if (trimmedMiddlename && /\s/.test(trimmedMiddlename)) {
    errors.Lastname = "No spaces allowed in Middle Name";
  }

  // Validate Last Name
  if (trimmedLastname && /\s/.test(trimmedLastname)) {
    errors.Lastname = "No spaces allowed in Last Name";
  }
  
  // Validate Username
  if (!values.Username) {
    errors.Username = "Username is mandatory";
  } else if (/\s/.test(values.Username)) {
    errors.Username = "No spaces allowed in Username";
  } else if (values.Username?.trim()?.length < 3) {
    errors.Username = "Username should be at least 3 characters long";
  }

  // Validate Email
  if (!trimmedEmailid) {
    errors.Emailid = "Email ID is mandatory";
  } else if (
    !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(trimmedEmailid)
  ) {
    errors.Emailid = "Invalid Email ID";
  } else if (
    !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(trimmedEmailid) ||
    trimmedEmailid.indexOf("@") !== trimmedEmailid.lastIndexOf("@")
  ) {
    errors.Emailid = "Email must contain exactly one '@' symbol";
  } else if (!/^[a-zA-Z0-9._-]+$/.test(trimmedEmailid.split("@")[0])) {
    errors.Emailid =
      "Email must contain only alphanumeric characters, dots, hyphens, and underscores";
  } else if (
    !/^[a-zA-Z0-9.-]+$/.test(trimmedEmailid.split("@")[1].split(".")[0])
  ) {
    errors.Emailid =
      "Email domain part must contain only alphanumeric characters, dots, and hyphens";
  }

  if(!trimmedPhonenumber){
    errors.Phonenumber = "Phone number is mandatory.";
  } else if (trimmedPhonenumber) {
    const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
    if (!phoneRegex.test(trimmedPhonenumber)) {
        errors.Phonenumber = "Phone number is invalid.";
    }
  }  

  // Validate Fax Number
  if (trimmedFaxnumber) {
    const faxNumberRegex = /^\d{3}-\d{3}-\d{4}$/;
    if (!faxNumberRegex.test(trimmedFaxnumber)) {
        errors.Faxnumber = "Fax No is invalid.";
    }
  }

  // Validate Company ID
  if (!values.Companyid) {
    errors.Companyid = "Company ID is mandatory.";
  }

  // Validate Web Role
  if (!values.Roleids || values.Roleids?.length == 0) {
    errors.Roleids = "At least one Web Role must be selected.";
  }

  // Validate User Type
   if (!values.Departmentid || values.Departmentid?.length == 0) {
    errors.Departmentid = "Please select Department.";
  }

  // Validate User Type
  if (!values.Usertypeid || values.Usertypeid?.length == 0) {
    errors.Usertypeid = "Please select User Type.";
  }
  
  return errors;
};

export default validateUserForm;
